/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Recording_CompleteInputs */



/**
* | output |
* | --- |
* | "Recording complete! You can preview or save your recording." |
*
* @param {Audio_Recorder_Recording_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_complete = /** @type {((inputs?: Audio_Recorder_Recording_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement terminé ! Vous pouvez prévisualiser ou sauvegarder votre enregistrement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufnahme abgeschlossen! Sie können Ihre Aufnahme in der Vorschau ansehen oder speichern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione completata! Puoi visualizzare in anteprima o salvare la registrazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запись завершена! Вы можете прослушать или сохранить запись.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Grabación completa! Puedes previsualizar o guardar la grabación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("录制完成！您可以预览或保存录制内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("録音が完了しました。録音内容をプレビューしたり保存したりできます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिकॉर्डिंग पूरी हुई! आप अपनी रिकॉर्डिंग का पूर्वावलोकन कर सकते हैं या उसे सहेज सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gravação concluída! Você pode pré-visualizar ou salvar sua gravação.")
	return /** @type {LocalizedString} */ ("Recording complete! You can preview or save your recording.")
});